import '../Style/Give.css'
import weather from '../Images/weather.png'
import gift from '../Images/gift.png'
import phone1 from '../Images/phone1.svg'
import ImageSlider from './Sliders';
import Purchase from './Purchase';
import BtnCoustom from './ButtonCstoum';

function Give() {
    return (
        <>
            
            <div className="container-fluid row give pt-5 pb-5 d-flex justify-content-center align-items-center m-0">
                

                <div className="cloud cloud1"><img src={ weather} alt='' /></div>
                <div className="cloud cloud2"><img src={ weather} alt='' /></div>
                <div className="cloud cloud3"><img src={ weather} alt='' /></div>
                <div className="cloud cloud4"><img src={ weather} alt='' /></div>
                <div className="cloud cloud5"><img src={ weather} alt='' /></div>

                


               <div className="text-center col-10 mb-4 content-layer">
                    <h1 className="display-4 col-lg-6 col-sm-10  m-auto mb-3 fw-bold ">Give the Gift of Parenting Superpowers</h1>
                    <p className="fw-bold  col-lg-6 col-sm-10 m-auto">
                    Help the new parents in your life feel confident, supported, and ready to tackle every milestone with expert guidance and tools, all in one place.</p>
                 </div>
                    </div>
                    <div className='gift-box text-center'>
                    <img src={gift} alt='' />
                <ImageSlider />
                
                <Purchase />
                 <div className="get-smile row col-11 col-lg-9 mx-auto mt-5 p-4 align-items-center ">
  <div className="col-12 col-md-8 text-start mb-4 mb-md-0 p-2">
    <h1 className="fw-bold mb-5">
      Because that 3am question about a sleep regression <br />
      shouldn't keep you up at night.
    </h1>
    <BtnCoustom />
  </div>

  <div className="col-12 col-md-4 text-center">
    <img className="img-pp img-fluid" src={phone1} alt="Phone Preview" style={{width:"80%"}} />
  </div>
</div>
                </div>

            
        </>
    )
}
export default Give;